import { Dialog as KDialog } from "@progress/kendo-react-dialogs";

import type { DialogProps as KDialogProps } from "@progress/kendo-react-dialogs";

import "./Dialog.scss";

export const Dialog = function render(props: KDialogProps) {
  const { className, autoFocus, ...otherProps } = props;
  return <KDialog autoFocus className={`tc-dialog ${className}`} {...otherProps} />;
};
